import { SET_FINANCIAL_PROFILE } from 'constants/actionTypes';

export const setFinancialProfile = financialProfile => ({
  type: SET_FINANCIAL_PROFILE,
  payload: { financialProfile },
});
